import { AppSubscription } from 'src/app/model/subscription';
import { SubscriptionDatabase } from 'src/app/model/subscriptionDatabase';

// Bag class with information to share in DatabaseHome component and its children
// --------------------------------------------------------------------------------------------------------
export class DbInfoBag {
    // current logged accountName
    AccountName: string;
    // current istance associated to subscription
    InstanceKey: string;

    // current subscription
    SubscriptionModel: AppSubscription;
    SubscriptionKey: string;

    // Name of subscription database (it is NOT the name of database!!!)
    SubDbName: string;

    SubscriptionDatabaseModel: SubscriptionDatabase;

    // informazioni configurazione dei dati di default/esempio
    defaultInfo: Object;
    sampleInfo: Object;
}
